var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000082331273550534257090000007146002114192846238_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 292 298.2",
    style: {
      enableBackground: "new 0 0 292 298.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.3,98.8L224,78.3C219.5,66,209.9,50.7,203,17l-21.1,54.7c-10.8-2.5-22.2-3.8-34-3.8 c-13.9,0-27.3,1.8-39.8,5.2L87.7,20.7c-6.9,33.7-16.5,49-21.1,61.3l-15.3,22C31.8,122.5,20,146.6,20,173c0,58,57.2,105,127.8,105 s127.8-47,127.8-105C275.6,144,261.3,117.8,238.3,98.8L238.3,98.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.4,190.8c-7.3,0-13.2-5.7-13.2-12.6c0-6.3,4.9-10,13.2-10s13.2,3.7,13.2,10 C97.7,185.2,91.7,190.8,84.4,190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.4,168.7c3,0,12.8,0.7,12.8,9.5c0,6.7-5.7,12.1-12.8,12.1s-12.8-5.4-12.8-12.1 C71.7,169.4,81.4,168.7,84.4,168.7 M84.4,167.7c-7.6,0-13.8,3.3-13.8,10.5s6.2,13.1,13.8,13.1s13.8-5.9,13.8-13.1 S92,167.7,84.4,167.7L84.4,167.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.9,190.1c-7.3,0-13.2-5.7-13.2-12.6c0-6.3,4.9-10,13.2-10s13.2,3.7,13.2,10 C228.1,184.5,222.2,190.1,214.9,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.9,168c3,0,12.8,0.7,12.8,9.5c0,6.7-5.7,12.1-12.8,12.1s-12.8-5.4-12.8-12.1 C202.1,168.7,211.9,168,214.9,168 M214.9,167c-7.6,0-13.8,3.3-13.8,10.5s6.2,13.1,13.8,13.1s13.8-5.9,13.8-13.1 S222.5,167,214.9,167L214.9,167z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/PHANTOM.991aab88e75808a40ca993dc8d883e17.svg";
export { ForwardRef as ReactComponent };